<template>
  <div class="container flex justify-center">
    <div class="card is-base max-w-md w-full p-6 lg:p-12 text-center">
      <svg
        id="98fdd3a5-2c74-40f5-a4f2-41d93d22b358"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        class="w-64 h-64"
        viewBox="0 0 909.67 748.22"
      ><defs><linearGradient
        id="d011afd7-26ae-4e21-bfb4-bf8e8278f380"
        x1="966.56"
        y1="410.81"
        x2="966.56"
        y2="349.8"
        gradientUnits="userSpaceOnUse"
      ><stop
        offset="0"
        stop-color="gray"
        stop-opacity="0.25"
      /><stop
        offset="0.54"
        stop-color="gray"
        stop-opacity="0.12"
      /><stop
        offset="1"
        stop-color="gray"
        stop-opacity="0.1"
      /></linearGradient><linearGradient
        id="b1272ad6-7fba-4513-8921-9c5943220b72"
        x1="517.02"
        y1="824.11"
        x2="517.02"
        y2="75.89"
        xlink:href="#d011afd7-26ae-4e21-bfb4-bf8e8278f380"
      /><linearGradient
        id="40add73e-d2f5-4381-9257-44e56f6ed5b0"
        x1="146.88"
        y1="637.21"
        x2="321.94"
        y2="637.21"
        xlink:href="#d011afd7-26ae-4e21-bfb4-bf8e8278f380"
      /><linearGradient
        id="44499e99-1e42-4717-8565-691e3cc41d41"
        x1="728.6"
        y1="487.08"
        x2="728.6"
        y2="484.08"
        xlink:href="#d011afd7-26ae-4e21-bfb4-bf8e8278f380"
      /><linearGradient
        id="a8bd5eea-1591-45ad-a86c-0410ca3890b3"
        x1="653.39"
        y1="341.18"
        x2="653.39"
        y2="183.08"
        xlink:href="#d011afd7-26ae-4e21-bfb4-bf8e8278f380"
      /></defs><g opacity="0.7"><path
        d="M986.71,360.7V349.8H932.24v50.39a10.62,10.62,0,0,0,10.62,10.62h33.23a10.62,10.62,0,0,0,10.62-10.62V389a14.16,14.16,0,1,0,0-28.33Zm0,22.88V366.14a8.72,8.72,0,1,1,0,17.43Z"
        transform="translate(-146.88 -75.89)"
        fill="url(#d011afd7-26ae-4e21-bfb4-bf8e8278f380)"
      /></g><path
        d="M985,362.4a12.93,12.93,0,1,0,12.93,12.93A12.93,12.93,0,0,0,985,362.4Zm0,20.89a8,8,0,1,1,8-8A8,8,0,0,1,985,383.29Z"
        transform="translate(-146.88 -75.89)"
        fill="#0072C4"
      /><path
        d="M985,362.4a12.93,12.93,0,1,0,12.93,12.93A12.93,12.93,0,0,0,985,362.4Zm0,20.89a8,8,0,1,1,8-8A8,8,0,0,1,985,383.29Z"
        transform="translate(-146.88 -75.89)"
        opacity="0.1"
      /><path
        d="M788.34,276.56h49.74a0,0,0,0,1,0,0v46a9.75,9.75,0,0,1-9.75,9.75H798.09a9.75,9.75,0,0,1-9.75-9.75v-46A0,0,0,0,1,788.34,276.56Z"
        fill="#0072C4"
      /><path
        d="M976,352.45v46a9.7,9.7,0,0,1-9.7,9.7h5a9.7,9.7,0,0,0,9.7-9.7v-46Z"
        transform="translate(-146.88 -75.89)"
        opacity="0.1"
      /><path
        d="M945,315.37a2.9,2.9,0,0,0-2.2,1.12c-.65,1.18.53,2.52,1.61,3.33,2,1.5,4.09,3,5.45,5.07s1.78,5,.3,7c-1.93,2.62-6.55,3.19-7,6.41-.29,2.07,1.5,3.84,3.32,4.88,4.48,2.57,10.26,3.25,13.5,7.27,1.34-2.76,4.35-4.36,7.34-5s6.1-.63,9.14-1.09A3.16,3.16,0,0,0,979,343c.85-1.72-1.57-3.79-.73-5.51.64-1.32,2.5-1.21,3.86-1.74,2.22-.86,3.13-3.71,2.5-6s-2.41-4.09-4.28-5.56c-5-4-11.1-6.29-17.23-8-2.85-.78-6.2-2-9.16-2.12S947.86,314.89,945,315.37Z"
        transform="translate(-146.88 -75.89)"
        fill="#eee"
      /><line
        x1="449.06"
        y1="344.02"
        x2="345.06"
        y2="668.02"
        fill="none"
        stroke="#e0e0e0"
        stroke-miterlimit="10"
        stroke-width="8"
      /><g opacity="0.7"><path
        d="M676.52,780.4c-12.79.74-24.19,11.46-24.19,11.46l-5.51-13.67-.45.15c2.69-11.78,57.47-254.72,2.63-275.66-42.13-16.09-86.82-36-121.84-35.26V410h49.09v-2h38.86c7.45-5.32-3.38-9-15.47-11.27a11.06,11.06,0,0,0,1.3-1.83l62.24-111.67s14.32-23.52,5.11-34.77-22.5,28.64-22.5,28.64l-51.13,73.63S543,296.92,510.22,270.17A57.47,57.47,0,0,0,498,260.93c-6-4.05-10.53-6.16-12.77-5.33l-.06,0a57.29,57.29,0,0,0-15.28-2.08H465.8v-8.39a65.61,65.61,0,0,0,40.53-38.4,73.7,73.7,0,0,0,5.84-64.17,4.26,4.26,0,0,0,1.72-.6c1.85-1.19,2-3.8,1.86-6a45.56,45.56,0,0,0-23.12-35.62c-5.18-2.83-11.12-4.79-14.94-9.29-3.28-3.87-4.66-9.28-8.64-12.44-4.72-3.75-11.54-3.11-17.33-1.43a63.06,63.06,0,0,0-18.09,8.54c-6.26,4.29-11.92,9.8-19.13,12.18-5.12,1.69-10.68,1.65-15.84,3.24a26.6,26.6,0,0,0-17.12,16.69,34.75,34.75,0,0,0-1.46,13,73.22,73.22,0,0,0-7.35,16.71l-1.16.63,1.12-.5a73.62,73.62,0,0,0,20.74,75.09,65.55,65.55,0,0,0,31.45,22.32v10.15a77.33,77.33,0,0,0-25.1,10.28h0s-.65.4-1.77,1.16l-.34.23c-7.57,5.14-32.93,23.9-32.07,44.18q0,1.17,0,2.35a78,78,0,0,0-2.09,17.88V478.54A72.28,72.28,0,0,0,379,523.37c-21.34,4.78-34.94,12-34.94,20.11a6.55,6.55,0,0,1,0,2c0,14.4,43,26.08,96.13,26.08,6.42,0,12.69-.17,18.76-.5l60,48.56L422.85,774.1s-31.7,24.54-7.16,32.73,74.66,14.32,74.66,14.32,8.18-14.32-3.07-20.45-26.59-3.07-26.59-3.07l2-12.27s166.7-143.18,131.93-192.26c-6.65-9.39-13.3-19.08-20-28.62l26.24,2.39,6,224.76.75-.24c-1.5,4.42-12.1,37.74,11.4,32.1,25.16-6,70.93-27.33,70.93-27.33S689.31,779.66,676.52,780.4ZM576.25,393.66l-49.09-14.25v-42L580.51,394C577.89,393.79,576.25,393.66,576.25,393.66Z"
        transform="translate(-146.88 -75.89)"
        fill="url(#b1272ad6-7fba-4513-8921-9c5943220b72)"
      /></g><circle
        cx="298.06"
        cy="99.02"
        r="72"
      /><path
        d="M526.94,339.91l54.95,58.33a10.73,10.73,0,0,0,17.19-2.13l60.86-109.19-17-6-50,72s-93.87-97.84-107-93S526.94,339.91,526.94,339.91Z"
        transform="translate(-146.88 -75.89)"
        fill="#0072C4"
      /><line
        x1="275.06"
        y1="466.02"
        x2="194.06"
        y2="676.02"
        fill="none"
        stroke="#bdbdbd"
        stroke-miterlimit="10"
        stroke-width="5"
      /><line
        x1="315.06"
        y1="466.02"
        x2="396.06"
        y2="676.02"
        fill="none"
        stroke="#bdbdbd"
        stroke-miterlimit="10"
        stroke-width="5"
      /><ellipse
        cx="295.06"
        cy="467.52"
        rx="94"
        ry="25.5"
        fill="#b84733"
      /><ellipse
        cx="295.06"
        cy="465.52"
        rx="94"
        ry="25.5"
        fill="#f55f44"
      /><line
        x1="255.5"
        y1="512.15"
        x2="344.19"
        y2="539.48"
        fill="none"
        stroke="#bdbdbd"
        stroke-miterlimit="10"
        stroke-width="5"
      /><line
        x1="334.61"
        y1="512.15"
        x2="245.92"
        y2="539.48"
        fill="none"
        stroke="#bdbdbd"
        stroke-miterlimit="10"
        stroke-width="5"
      /><path
        d="M296.15,182h27.91a56,56,0,0,1,56,56V386a0,0,0,0,1,0,0h-160a0,0,0,0,1,0,0V258.11A76.09,76.09,0,0,1,296.15,182Z"
        fill="#0072C4"
      /><path
        d="M220.06,386h160a0,0,0,0,1,0,0v87a0,0,0,0,1,0,0h-89a71,71,0,0,1-71-71V386A0,0,0,0,1,220.06,386Z"
        fill="#39447a"
      /><path
        d="M369.1,317.95l97.84,93h108v-14l-93-27-79.55-98.24S366.26,294,369.1,317.95Z"
        transform="translate(-146.88 -75.89)"
        opacity="0.05"
      /><path
        d="M369.1,315.95l97.84,93h108v-14l-93-27-79.55-98.24S366.26,292,369.1,315.95Z"
        transform="translate(-146.88 -75.89)"
        fill="#0072C4"
      /><path
        d="M574.94,394.91s52,4,38,14h-38Z"
        transform="translate(-146.88 -75.89)"
        fill="#fda57d"
      /><path
        d="M642.94,280.91s13-39,22-28-5,34-5,34Z"
        transform="translate(-146.88 -75.89)"
        fill="#fda57d"
      /><polygon
        points="220.06 386.02 220.06 390.68 380.06 391.02 380.06 386.02 220.06 386.02"
        opacity="0.05"
      /><path
        d="M491.4,554.45,599,564.26,604.86,784l38.53-12.54s57.63-249,2.68-270-114.35-48.63-149.81-26.1S491.4,554.45,491.4,554.45Z"
        transform="translate(-146.88 -75.89)"
        fill="#39447a"
      /><path
        d="M497.94,486.91s59,30,67,64"
        transform="translate(-146.88 -75.89)"
        opacity="0.1"
      /><path
        d="M434.94,547.91l84,68-94,151,39,11s163-140,129-188-68-104-110-105S434.94,547.91,434.94,547.91Z"
        transform="translate(-146.88 -75.89)"
        fill="#39447a"
      /><polygon
        points="420.06 251.02 441.06 287.02 446.06 277.02 420.06 251.02"
        opacity="0.05"
      /><path
        d="M424.94,766.91s-31,24-7,32,73,14,73,14,8-14-3-20-26-3-26-3l2-12Z"
        transform="translate(-146.88 -75.89)"
        fill="#333"
      /><path
        d="M605.76,783.32s-13.62,37.76,11,31.86,69.36-26.73,69.36-26.73-.61-16.11-13.12-15.39-23.65,11.2-23.65,11.2l-5.39-13.37Z"
        transform="translate(-146.88 -75.89)"
        fill="#333"
      /><rect
        x="280.06"
        y="147.02"
        width="40"
        height="60"
        rx="20"
        ry="20"
        fill="#fda57d"
      /><path
        d="M446.94,224.91a20,20,0,0,0-20,20v6.8a64,64,0,0,0,40,0v-6.8A20,20,0,0,0,446.94,224.91Z"
        transform="translate(-146.88 -75.89)"
        opacity="0.05"
      /><circle
        cx="300.06"
        cy="113.02"
        r="64"
        fill="#fda57d"
      /><path
        d="M382.94,186s16,4.12,25-14.06,16-28.1,53-17.36,44.44,12.06,46.22,1.9c1.22-6.94-11.94-23.81-20.4-33.79-4.12-4.87-10.85-7.78-18-7.78H426.94l-25,11.57-19,16.53-4,22.32Z"
        transform="translate(-146.88 -75.89)"
        opacity="0.05"
      /><path
        d="M382.94,184s16,4.12,25-14.06,16-28.1,53-17.36,44.44,12.06,46.22,1.9c1.22-6.94-11.94-23.81-20.4-33.79-4.12-4.87-10.85-7.78-18-7.78H426.94l-25,11.57-19,16.53-4,22.32Z"
        transform="translate(-146.88 -75.89)"
      /><ellipse
        cx="242.56"
        cy="108.02"
        rx="6.5"
        ry="13"
        fill="#fda57d"
      /><path
        d="M384.79,150.46c-1.48-8.37-2.94-17.16-.24-25.22a26,26,0,0,1,16.74-16.32c5-1.55,10.48-1.52,15.49-3.17,7.05-2.32,12.58-7.71,18.71-11.91a61.66,61.66,0,0,1,17.69-8.35c5.66-1.64,12.33-2.27,16.95,1.4,3.88,3.09,5.23,8.38,8.44,12.16,3.74,4.4,9.54,6.31,14.61,9.08A44.54,44.54,0,0,1,515.77,143c.17,2.15,0,4.7-1.82,5.86a6.48,6.48,0,0,1-3.65.67c-25.58-.37-51.19-.73-76.66-3.08-7.92-.73-15.85-1.65-23.8-1.35a77.85,77.85,0,0,0-35,9.89"
        transform="translate(-146.88 -75.89)"
      /><g opacity="0.7"><path
        d="M320.88,594.15a34,34,0,0,0-13.47-36c-3-2-6.28-3.53-9-5.84-4.56-3.84-7.17-9.51-9.05-15.18-4.52-13.58-5.95-28.81-13.88-41.08-7.22-11.17-21.27-14.44-33.74-15.55-4.54-.41-9.31-.62-13.46,1.26-6.95,3.14-10.26,11.35-10.57,19s1.67,15.14,2.17,22.74-.86,16-6.48,21.14-13.65,5.77-21.1,6.8a139.71,139.71,0,0,0-28.59,7.1c-7.77,2.83-16.42,7.93-16.79,16.19-.3,6.75,5.15,12.14,9.24,17.51,7.65,10,11.47,23.29,8.88,35.64-2.64,12.57-11.47,23.36-13.08,36.11-.41,3.24-.29,6.68,1.28,9.54a17.45,17.45,0,0,0,4.83,5.11c4.8,3.71,10.16,6.69,14.7,10.71,9.47,8.39,14.6,20.56,18.55,32.58.38,1.16.72,2.33,1.08,3.49h-9.31a34.53,34.53,0,0,0-34.43,34.43h0a34.53,34.53,0,0,0,34.43,34.43h93a34.53,34.53,0,0,0,34.43-34.43h0A34.53,34.53,0,0,0,276,725.36H250.54c6-8.07,12.32-15.65,21.62-18.76s20.55-1.28,27.85-7.77c3.56-3.16,5.45-7.84,6.32-12.52a37.29,37.29,0,0,0-4.08-24.76c-2.93-5.23-7.21-10-8.14-15.9-.79-5.06,1-10.19,3.51-14.68C304.65,618.18,317.09,608.25,320.88,594.15Z"
        transform="translate(-146.88 -75.89)"
        fill="url(#40add73e-d2f5-4381-9257-44e56f6ed5b0)"
      /></g><path
        d="M241.37,487.95c-4.32-.39-8.86-.59-12.82,1.2-6.61,3-9.77,10.81-10.07,18.06s1.59,14.41,2.06,21.66-.82,15.22-6.17,20.13-13,5.49-20.09,6.47a133,133,0,0,0-27.23,6.76c-7.4,2.69-15.64,7.56-16,15.42-.28,6.43,4.9,11.56,8.8,16.67,7.29,9.57,10.92,22.18,8.45,33.94-2.52,12-10.93,22.25-12.45,34.39-.39,3.08-.28,6.36,1.22,9.08a16.61,16.61,0,0,0,4.6,4.87c4.57,3.53,9.67,6.37,14,10.2,9,8,13.9,19.58,17.66,31A251.28,251.28,0,0,1,202,752.24c7.77-5,17.81-4.92,26.1-9,17.65-8.65,23.59-33.73,42.23-40,8.82-2.95,19.57-1.22,26.52-7.4,3.39-3,5.19-7.46,6-11.92A35.51,35.51,0,0,0,299,660.39c-2.79-5-6.87-9.5-7.76-15.14-.76-4.82,1-9.7,3.34-14,6.7-12.18,18.55-21.63,22.16-35.06a32.37,32.37,0,0,0-12.83-34.32c-2.83-1.91-6-3.36-8.6-5.56-4.35-3.66-6.82-9.06-8.62-14.45-4.31-12.93-5.67-27.44-13.22-39.12C266.62,492.12,253.24,489,241.37,487.95Z"
        transform="translate(-146.88 -75.89)"
        fill="#4db6ac"
      /><path
        d="M241.24,488.39S257.64,708,215,745.75"
        transform="translate(-146.88 -75.89)"
        fill="none"
        stroke="#535461"
        stroke-miterlimit="10"
        opacity="0.6"
      /><rect
        x="5.85"
        y="645.27"
        width="154.09"
        height="65.57"
        rx="32.78"
        ry="32.78"
        fill="#0072C4"
      /><path
        d="M151.09,573.63s41.91-4.89,93.08,26.24"
        transform="translate(-146.88 -75.89)"
        fill="none"
        stroke="#535461"
        stroke-miterlimit="10"
        opacity="0.6"
      /><path
        d="M243.35,626.08s23.29-38.52,73.29-45.89"
        transform="translate(-146.88 -75.89)"
        fill="none"
        stroke="#535461"
        stroke-miterlimit="10"
        opacity="0.6"
      /><path
        d="M155.19,663s58.09-9.85,84.78,6.55"
        transform="translate(-146.88 -75.89)"
        fill="none"
        stroke="#535461"
        stroke-miterlimit="10"
        opacity="0.6"
      /><path
        d="M236.66,692.05s30.41-13.8,64.62-2.59"
        transform="translate(-146.88 -75.89)"
        fill="none"
        stroke="#535461"
        stroke-miterlimit="10"
        opacity="0.6"
      /><path
        d="M728.6,487.08a1.5,1.5,0,0,0,0-3,1.5,1.5,0,0,0,0,3Z"
        transform="translate(-146.88 -75.89)"
        fill="url(#44499e99-1e42-4717-8565-691e3cc41d41)"
      /><line
        x1="801.82"
        y1="344.02"
        x2="905.82"
        y2="714.11"
        fill="none"
        stroke="#e0e0e0"
        stroke-miterlimit="10"
        stroke-width="8"
      /><rect
        x="344.63"
        y="333.18"
        width="561.61"
        height="21.88"
        fill="#e0e0e0"
      /><rect
        x="483.06"
        y="328.02"
        width="92"
        height="13"
        rx="6.5"
        ry="6.5"
        fill="#535461"
      /><g opacity="0.7"><rect
        x="539.06"
        y="183.08"
        width="228.66"
        height="158.1"
        rx="28.22"
        ry="28.22"
        fill="url(#a8bd5eea-1591-45ad-a86c-0410ca3890b3)"
      /></g><rect
        x="543.13"
        y="185.99"
        width="216.61"
        height="155.18"
        rx="26.84"
        ry="26.84"
        fill="#3e3f49"
      /><rect
        x="546.13"
        y="185.99"
        width="216.61"
        height="155.18"
        rx="26.84"
        ry="26.84"
        fill="#535461"
      /><circle
        cx="664.56"
        cy="262.52"
        r="7"
        fill="#e0e0e0"
      /></svg>
      <h2 class="my-4">
        We're getting your project ready.
      </h2>
      <p>We're in the process of finialising your grant offer letter for you and your partners. We will notify you, and your partners, via email with your electronic contracts when they become available.</p>
      <div class="mx-auto max-w-xs mt-8">
        <app-button
          @click="goToApplicationFeedback"
        >
          Interview Feedback
        </app-button>
      </div>
    </div>
  </div>
</template>
<script>
import { userProjectMixin } from '../../mixins/userProject.js'
export default {
  name: 'NoContract',
  mixins: [userProjectMixin],
	methods: {
		goToApplicationFeedback() {
			Turbolinks.visit(route('applications.view', { application: this.project.uuid}) + '#feedback')
		}
	}
}
</script>